import { render } from "./WorkloadApprovalDialog.vue?vue&type=template&id=dff7a43a&scoped=true"
import script from "./WorkloadApprovalDialog.vue?vue&type=script&lang=js"
export * from "./WorkloadApprovalDialog.vue?vue&type=script&lang=js"

import "./WorkloadApprovalDialog.vue?vue&type=style&index=0&id=dff7a43a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dff7a43a"]])

export default __exports__